
export const LOCATION_CHANGE = 'storefront/routing/routing/LOCATION_CHANGE';


export const changeLocation = (location, action) => ({
    type: LOCATION_CHANGE,
    location,
    action
});
